import Vue from 'vue'
import store from './store'
import router from './router'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import AxiosPlugin from './utils/request'


//import axios from 'axios'

//import fns from '@/assets/js/jing.js'
import 'babel-polyfill'

import '@/assets/css/iconfont.css'


Vue.use(ElementUI)
Vue.use(AxiosPlugin)
Vue.config.productionTip = false
Vue.use(require('vue-wechat-title'))
new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#App')
